//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Typography } from '@mui/material'
import TableCell from '@mui/material/TableCell'
import { FieldMetaData } from '@shared/SchemaTypes'
import * as React from 'react'
import { ReactElement } from 'react'
import { SchemaDescription, SchemaFieldDescription } from 'yup'
import ViewField from './ViewField'

import assert from 'assert'

export default class TableColumn {
  propName: string
  label: string
  schema: SchemaDescription
  fieldMetaData: FieldMetaData
  minWidth: number
  align: 'left' | 'right' | 'center' | 'inherit' | 'justify'
  format?: (value: string | number | Date) => string

  constructor(
    fieldSchema: SchemaFieldDescription,
    options?: {
      minWidth?: number
      format?: (value: string | number | Date) => string
      align?: 'left' | 'right' | 'center' | 'inherit' | 'justify'
    }
  ) {
    const schemaDescription = fieldSchema as SchemaDescription

    const fieldMetaData = schemaDescription.meta as FieldMetaData
    this.fieldMetaData = fieldMetaData
    this.schema = schemaDescription
    this.propName = fieldMetaData?.propName
    this.label = schemaDescription.label ?? ''
    this.minWidth = options?.minWidth ?? 100
    this.align = options?.align ?? 'right'
    this.format = options?.format
  }

  getDisplayString(dataObject: object): string {
    const dataValue = (dataObject as Record<string, Date | string>)[this.propName]
    if (this.schema.type === 'date') {
      // prettier-ignore
      return typeof dataValue === 'string'
        ? new Date(dataValue).toLocaleDateString()
        : dataValue instanceof Date
        ? dataValue.toLocaleDateString()
        : dataValue
    }

    return dataValue as string
  }

  getCellContents(dataObject: object): ReactElement {
    const value = (dataObject as Record<string, string | number | Date>)[this.propName]

    if (this.format != null) {
      return (
        <React.Fragment>
          <Typography variant="bodyBold" gutterBottom component="div">
            {this.format(value)}
          </Typography>
        </React.Fragment>
      )
    } else {
      assert(this.schema, 'SCHEMA NULL')
      return <ViewField inTable={true} fieldSchema={this.schema} dataObject={dataObject}></ViewField>
    }
  }

  getTableCell(obj: object): ReactElement {
    // I DO not think this is needed anymore
    //  const value = (obj as Record<string, string>)[this.propName] as string
    // if (this.propName === 'logo') {
    //   const url = urlForFile(chainId, deploymentName, `${value}/logo.png`)
    //   return (
    //     <TableCell key={this.propName} align={this.align}>
    //       <img style={{ maxWidth: '50px', maxHeight: '50px' }} src={url} alt={value} loading="lazy" />
    //     </TableCell>
    //   )
    // }

    return (
      <TableCell key={this.propName} align={this.align}>
        {this.getCellContents(obj)}
      </TableCell>
    )
  }
}
